var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{staticStyle:{"font-family":"Microsoft JhengHei"}},[_c('v-container',{attrs:{"md":"12"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }